import { useContext } from "react";
import {
    TemplateApplicationContext,
    type TemplateApplicationContextValue,
} from "./templateApplicationContext";

export const useTemplateApplication = (): TemplateApplicationContextValue => {
    const ctx = useContext(TemplateApplicationContext);
    if (!ctx) {
        throw new Error(
            "useTemplateApplication must be used within TemplateApplicationProvider",
        );
    }
    return ctx;
};
